import React from "react"
import styled from "@emotion/styled"
import { GatsbyImage } from "gatsby-plugin-image"

export default class PreviewSection extends React.PureComponent {
  render() {
    const { transform } = this.props;
    return <Wrapper className="section">
      <div className="section_inner">
        <>
          <div id={`preview_${transform.slug}`} className="name preview_content">
            <span dangerouslySetInnerHTML={
  						{ __html: transform.label }
  					} />
            {` `}
            <small>
              <a href="#top">top</a>
            </small>
          </div>
          <div className="images">
            {transform.previewImages.map((img, j) => (
              <div className="image" key={`preview_transform_${transform.slug}_image_${j}`}>
                <GatsbyImage className="Img" image={img.file.image.childImageSharp.gatsbyImageData} key={`preview_transform_${transform.slug}_image_${j}_img`} alt=""/>
                <div className="label">{img.site} / { img.os } / { img.app }</div>
              </div>
            ))}
          </div>
        </>
      </div>
    </Wrapper>
  }
}

const Wrapper = styled("div")`
.name { font-size: 20px; margin: 10px 0 30px; }
.name a { color: #000; }
.images { float: left; width: 100% }
.image {
  float: left;
  padding: 0 8px 12px 0;
  width: 33%;
  box-sizing: border-box;
  @media screen and (max-width: 1415px) {
  	width: 50%;
  }
  @media screen and (max-width: 600px) {
    width: 100%;
    padding-right: 0;
  }
}
.image:nth-of-type(3n+1) {
  clear:left;
  @media screen and (max-width: 1415px) {
  	clear: none;
  }
  @media screen and (max-width: 600px) {
    clear: none;
  }
}
.image:nth-of-type(2n+1) {
  @media screen and (max-width: 1415px) {
  	clear: left;
  }
  @media screen and (max-width: 600px) {
    clear: none;
  }
}
.image div.label {
	float: left;
	clear: left;
	font-size: 13px;
	font-family: monospace;
}
`
